"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }// Before a patient file is saved to a device, the user confirms they
// understand it leaves BloomText. Once a user has, this device doesn't ask
// them again. Each platform renders the dialog for the pending ask.

 const DOWNLOAD_CONSENT_TITLE = 'Save this file to your device?'; exports.DOWNLOAD_CONSENT_TITLE = DOWNLOAD_CONSENT_TITLE
 const DOWNLOAD_CONSENT_BODY = 'Saved files leave BloomText. They can sync to personal iCloud, ' +
  "Google Photos or other cloud accounts, and BloomText can't delete them later. " +
  'Each download is recorded with who saved it.'; exports.DOWNLOAD_CONSENT_BODY = DOWNLOAD_CONSENT_BODY
 const DOWNLOAD_CONSENT_CHECKBOX = 'I understand the risks'; exports.DOWNLOAD_CONSENT_CHECKBOX = DOWNLOAD_CONSENT_CHECKBOX
 const DOWNLOAD_CONSENT_CONFIRM = 'Download'; exports.DOWNLOAD_CONSENT_CONFIRM = DOWNLOAD_CONSENT_CONFIRM
 const DOWNLOAD_CONSENT_CANCEL = 'Cancel'; exports.DOWNLOAD_CONSENT_CANCEL = DOWNLOAD_CONSENT_CANCEL

// localStorage on web and desktop, AsyncStorage on mobile.





const storageKey = (userKey) => `bt_download_consent_${userKey}`



 const createDownloadConsent = (storage) => {
  // The ask on screen; one object per ask, so a store hook can compare it.
  let pending = null
  const listeners = new Set()
  const notify = () => listeners.forEach(listener => listener())

  // Storage that can't be read or written counts as never acknowledged.
  const acknowledged = async (userKey) => {
    try {
      return (await storage.getItem(storageKey(userKey))) === '1'
    } catch (e) {
      return false
    }
  }
  const remember = async (userKey) => {
    try {
      await storage.setItem(storageKey(userKey), '1')
    } catch (e2) {
      // Asked again next time.
    }
  }

  return {
    /** Resolves true once the user may download: acknowledged before on this
     * device, or now. False when they cancel. */
    request: async (userKey) => {
      if (await acknowledged(userKey)) return true
      _optionalChain([pending, 'optionalAccess', _ => _.resolve, 'call', _2 => _2(false)])
      return new Promise((resolve) => {
        pending = { shown: { userKey }, resolve }
        notify()
      })
    },

    /** The dialog's answer to the pending ask. */
    answer: (accepted) => {
      const asked = pending
      if (!asked) return
      pending = null
      notify()
      if (accepted) remember(asked.shown.userKey).catch(() => undefined)
      asked.resolve(accepted)
    },

    /** The ask the dialog shows, if any. */
    current: () => _nullishCoalesce(_optionalChain([pending, 'optionalAccess', _3 => _3.shown]), () => ( null)),

    subscribe: (listener) => {
      listeners.add(listener)
      return () => { listeners.delete(listener) }
    },
  }
}; exports.createDownloadConsent = createDownloadConsent


